// tslint:disable:radix
import * as _ from 'lodash';
import { GET_ALL_CONDITIONS_REQUESTED } from '../../condition/condition.actions';
import { GET_ALL_STATUSES_REQUESTED } from '../../status/status.actions';
import { GET_ALL_STYLES_REQUESTED } from '../../style/style.actions';
import { GET_ALL_SIZES_REQUESTED } from '../../size/size.actions';
import { GET_ALL_DESIGNERS_REQUESTED } from '../../designer/designer.actions';
import { GET_ALL_CATEGORIES_REQUESTED } from '../../category/category.actions';
import { GET_ALL_WARDROBES_REQUESTED } from '../../wardrobe/wardrobe.action';
import { GET_ALL_PROVIDERS_REQUESTED } from '../../provider/provider.actions';
import { GET_ALL_PROCESS_STATUSES_REQUESTED } from '../../process-status/process-status.actions';
import { GET_ALL_PROCESS_TYPES_REQUESTED } from '../../process-types/process-type.actions';
import { GET_ALL_CURRENCYS_REQUESTED } from '../../currency/currency.actions';
import { GET_ALL_COLORS_REQUESTED } from '../../color/color.action';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import store from './../../../store/store.module';
import { FETCH_PRODUCT_DETAIL_REQUESTED, FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED } from '../detail/detail.actions';
import {
  UPDATE_PRODUCT_REQUESTED,
  DELETE_PRODUCT_REQUESTED,
  CLONE_PRODUCT_REQUESTED,
  REPROCESS_IMAGE_REQUESTED,
  ROTATE_IMAGE_REQUESTED,
  PRODUCT_EDIT_PAGE_DELETE_IMAGE_REQUESTED,
  UPDATE_PRODUCT_SOLD_FORCE_REQUESTED
} from './edit.actions';
import ArrayList from '../../../models/ArrayList';
import { UtilityService } from '../../../common/services/utility/utility.service';
import { FILTER_USERS_REQUESTED } from '../../user/list/list.actions';
import { PRODUCT_COMP } from '../product.const';
import { Subject } from 'rxjs/Subject';
import { debounceTime } from 'rxjs/operators';
import Redirect from '../../../models/Redirect';
import { ADD_DATA_DELIVERY } from '../../delivery/create/create.actions';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { AppInjector } from '../../../app-injector';
import { AvailablePermissions } from '../../../app.const';
import { FETCH_CONSTANTS_REQUESTED } from '../../../store/constant/list/list.actions';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { FILTER_COLLECTIONS_REQUESTED } from '../../collection/list/list.actions';
import { PROCESS_STATUS_SELLING, PROCESS_STATUS_IN_REVIEW } from '../../../models/ProcessStatus';
import { shipping_types, SHIPPING_TYPES } from '../../../models/Product';
import { ApiService } from '../../../api/api.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-edit',
  templateUrl: './edit_v2.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponent implements OnInit, OnDestroy {
  public orderRegex = /\/order\/edit\/(.*)\?/;

  @ViewChild('confirmchangeseller') private confirmchangeseller: SwalComponent;
  @ViewChild('confirmchangecollection') private confirmchangecollection: SwalComponent;
  public confirmchangeProcessStatus = null;
  public productDeleteAllPermission = [AvailablePermissions.PRODUCT_DELETE_ALL];
  public productUpdateAllPermission = [AvailablePermissions.PRODUCT_UPDATE_ALL];
  public SHIPPING_TYPES = SHIPPING_TYPES;
  public SELF_SHIPPING = shipping_types.SELF_SHIPPING;
  public store = store;
  uploading = {
    process: false,
    error: false
  };
  public state = <any>store.getState();
  public utilityService;
  public mainCurrency;
  public categoryModel = {
    type_code: null,
    main_code: null,
    gender: null
  };
  public images = [];
  public emptyproduct = {
    sku: '',
    price: 0,
    process_status_id: null,
    process_type_id: null,
    provider_id: null,
    name: '',
    categories: [],
    wardrobes: [],
    designer_id: null,
    id: '',
    condition_id: null,
    currency_id: '',
    styles: [],
    size_id: null,
    heel_height: '',
    dimensions: '',
    color_id: null,
    material: '',
    description: '',
    original_price: 0,
    seller_id: null,
    approved: false,
    enabled: false,
    partner_sku: '',
    partner_url: '',
    partner_webhook_url: '',
    payout_type: 'auto_generated_payout',
    fix_payout_amount: 0,
    fix_payout_currency_id: '',
    calculated_payout_amount: 0,
    calculated_payout_currency_id: '',
    fixed_commission_rate: 0,
    collection_id: null,
    shipping_type: null,
    shipping_cost_intra_euro: 0,
    shipping_cost_international: 0,
    shipping_cost_international_currency_id: null,
    shipping_cost_intra_euro_currency_id: null,
    process_status_comment: '',
    private_comment: '',
    meta: {}
  };
  public product: any = { ...this.emptyproduct };
  public redirectData;
  public temporaryPriceView = 'active';
  public userSubject = new Subject<string>();
  public collectionSubject = new Subject<string>();
  public navigationSubscription: any;
  public _no_redirect = false;
  public sizes = [];
  public sortablejsOptions = {};
  public sortablejsDefaultOptions = {
    direction: 'horizontal'
  };

  constructor(private router: Router, private route: ActivatedRoute, utilityService: UtilityService, private api: ApiService) {
    this.utilityService = utilityService;
    // store.dispatch({ type: GET_ALL_CUSTOM_ATTRIBUTES_REQUESTED });
    store.dispatch({ type: GET_ALL_CURRENCYS_REQUESTED });
    store.dispatch({ type: GET_ALL_CATEGORIES_REQUESTED });
    store.dispatch({ type: GET_ALL_WARDROBES_REQUESTED });
    store.dispatch({ type: GET_ALL_DESIGNERS_REQUESTED });
    store.dispatch({ type: GET_ALL_SIZES_REQUESTED });
    store.dispatch({ type: GET_ALL_STYLES_REQUESTED });
    store.dispatch({ type: GET_ALL_STATUSES_REQUESTED });
    store.dispatch({ type: GET_ALL_CONDITIONS_REQUESTED });
    store.dispatch({ type: GET_ALL_PROCESS_STATUSES_REQUESTED });
    store.dispatch({ type: GET_ALL_PROCESS_TYPES_REQUESTED });
    store.dispatch({ type: GET_ALL_PROVIDERS_REQUESTED });
    store.dispatch({ type: GET_ALL_COLORS_REQUESTED });
    store.dispatch({ type: FETCH_CONSTANTS_REQUESTED });

    this.sortablejsOptions = {
      ...this.sortablejsDefaultOptions,
      onUpdate: (event: any) => {
        this.images.forEach((image, index) => {
          image.order = index;
        });
        this.sortAbleImage();
      }
    };

    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        store.dispatch({ type: FETCH_PRODUCT_DETAIL_REQUESTED, data: this.getProductId() });
        this.product = { ...this.emptyproduct };
        this.redirectData = this.utilityService.getRedirectData();
        let subscribeProduct = store.subscribe(() => {
          if ((store as any).getState().Product.detail.fetched && (store as any).getState().Size.all.fetched) {
            let newVal = (store as any).getState().Product.detail.data;
            console.log('____log', this.product);

            Object.keys(this.product).forEach((attrKey) => {
              if (newVal[attrKey] instanceof ArrayList) {
                this.product[attrKey] = newVal[attrKey] ? newVal[attrKey].getId() : this.emptyproduct ? this.emptyproduct[attrKey] : '';
              } else {
                this.product[attrKey] = newVal[attrKey] ? newVal[attrKey] : this.emptyproduct ? this.emptyproduct[attrKey] : '';
              }
            });
            if (this.product.fix_payout_amount) {
              this.product.payout_type = 'fix_payout_amount';
            } else if (this.product.fixed_commission_rate) {
              this.product.payout_type = 'fixed_commission_rate';
            } else {
              this.product.payout_type = 'auto_generated_payout';
            }
            if (newVal.user) {
              this.userSubject.next(newVal.user.email ? newVal.user.email : '');
            }
            if (newVal.collection) {
              this.collectionSubject.next(newVal.collection.name ? newVal.collection.name : '');
            }
            this.images = store.getState().Product.detail.data.media.getContent();
            this.sizes = this.getSizes();
            subscribeProduct();
          }
        });
        store.subscribe(() => {
          this.checkCategory();
          this.checkCurrency();
          this.checkMedia();
        });
        this.subscribeToUser();
        this.subscribeToCollection();
      }
    });
  }

  ngOnInit() {}

  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }

  sortAbleImage() {
    this.api.product.updatePositionImage(this.getProductId(), { medias: this.images }).subscribe((res) => {
      AppInjector.get(NotificationService).show('success', 'Change position media success', 3000);
      store.dispatch({ type: FETCH_PRODUCT_DETAIL_REQUESTED, data: this.getProductId() });
    });
  }

  processStatusChanged(process_status_id) {
    if (!_.isNil(process_status_id)) {
      const process_status = _.find(this.store.getState().Product.detail.data.allowed_transition.getContent(), { id: this.parseInt(process_status_id) });
      if (process_status.name === PROCESS_STATUS_IN_REVIEW) {
        this.product.approved = false;
      }
      if (process_status.name === PROCESS_STATUS_SELLING) {
        this.product.approved = true;
      }
    }
  }

  approvedChanged(approved) {
    if (approved) {
      const selling_status = _.find(this.store.getState().Product.detail.data.allowed_transition.getContent(), { name: PROCESS_STATUS_SELLING });
      if (selling_status) this.product.process_status_id = selling_status.getId();
    } else {
      const in_review_status = _.find(this.store.getState().Product.detail.data.allowed_transition.getContent(), { name: PROCESS_STATUS_IN_REVIEW });
      if (in_review_status) this.product.process_status_id = in_review_status.getId();
    }
  }

  checkCategory() {
    if ((store as any).getState().Category.all.fetched) {
      let allCategories = (store as any).getState().Category.all.items;
      if (this.product.categories.length > 0) {
        if (this.product.categories[0]) {
          this.categoryModel = allCategories.find((s) => parseInt(this.product.categories[0]) === s.id);
        }
      }
    }
  }

  checkMedia() {
    if (store.getState().Product.detail.data) {
      if (store.getState().Product.detail.data.media) {
        this.images = store.getState().Product.detail.data.media.getContent();
      }
    }
  }

  getSizes() {
    if ((store as any).getState().Product.detail.fetched) {
      let designer = (store as any).getState().Product.detail.data.designer;
      if (designer) {
        if (designer.is_strictly_using_own_sizing && designer.sizes && Array.isArray(designer.sizes)) {
          if (designer.sizes.length > 0) {
            return designer.sizes;
          }
        }
      }
    }
    return (store as any).getState().Size.all.items;
  }
  addImage() {
    if (this.images.length < 10) {
      this.images.push({});
    }
  }

  complete(event, index) {
    this.images[index] = event.data[0];
  }

  errors(event) {
    console.log(event);
  }

  changePayoutType(type) {
    this.product.payout_type = type;
  }
  checkCurrency() {
    if ((store as any).getState().Currency.all.fetched) {
      let allCurrencies = (store as any).getState().Currency.all.items;
      this.mainCurrency = allCurrencies.find((s) => s.base);
    }
  }
  getProductId() {
    let productId = this.route.snapshot.paramMap.get('id');
    return productId;
  }

  rotateImage(mediaId) {
    store.dispatch({ type: ROTATE_IMAGE_REQUESTED, product_id: this.getProductId(), media_id: mediaId });
  }

  onSubmit(form, type = 'IN_REVIEW', force = false, no_redirect = false) {
    form.submitted = true;
    if (!force) {
      this._no_redirect = no_redirect;
      if ((store as any).getState().Product.detail.data.collection_id) {
        if (this.product.seller_id !== (store as any).getState().Product.detail.data.seller_id) {
          this.confirmchangeProcessStatus = type;
          this.confirmchangeseller.show();
          return;
        }
      }
      if (this.product.collection_id !== (store as any).getState().Product.detail.data.collection_id) {
        this.confirmchangeProcessStatus = type;
        this.confirmchangecollection.show();
        return;
      }
    }
    if (!this.product.partner_sku) {
      delete this.product.partner_sku;
    }
    if (!this.product.private_comment) {
      delete this.product.private_comment;
    }
    if (!this.product.process_status_comment) {
      delete this.product.process_status_comment;
    }
    if (!this.product.size_id) {
      delete this.product.size_id;
    }
    if (!this.product.process_status_id) {
      delete this.product.process_status_id;
    }
    if (!this.product.process_type_id) {
      delete this.product.process_type_id;
    }
    if (!this.product.provider_id) {
      delete this.product.provider_id;
    }
    if (!this.product.designer_id) {
      delete this.product.designer_id;
    }
    if (!this.product.condition_id) {
      delete this.product.condition_id;
    }
    if (!this.product.seller_id) {
      delete this.product.seller_id;
    }
    if (!this.product.color_id) {
      delete this.product.color_id;
    }
    if (!this.product.shipping_cost_international_currency_id) {
      delete this.product.shipping_cost_international_currency_id;
    }
    if (!this.product.shipping_cost_intra_euro_currency_id) {
      delete this.product.shipping_cost_intra_euro_currency_id;
    }
    if (!this.product.currency_id) {
      this.product.currency_id = this.mainCurrency.id;
      this.product.fix_payout_currency_id = this.mainCurrency.id;
    }
    if (this.product.dimensions) {
      this.product.dimensions = this.product.dimensions
        .replace(/W|H|D|w|h|d|_|\s/g, '')
        .split('x')
        .map((s) => parseInt(s))
        .join('x');
    }
    if (this.product.payout_type === 'auto_generated_payout') {
      this.product.fix_payout_amount = 0;
      this.product.fixed_commission_rate = 0;
    } else if (this.product.payout_type === 'fixed_commission_rate') {
      this.product.fix_payout_amount = 0;
    } else if (this.product.payout_type === 'fix_payout_amount') {
      this.product.fixed_commission_rate = 0;
    }
    if (this.images) {
      this.product.media = {
        data: this.images.reduce((acc, url, i) => {
          const isExist = url.id;
          const data: any = {
            original_image_path: url.original_image_path || url.full_path
          };
          if (isExist) {
            data.id = isExist;
          }
          acc.push(data);
          return acc;
        }, [])
      };
    }
    if (type !== 'REJECTED') {
      if (!form.valid) {
        return;
      }
    }
    if (type) {
      let PROCESS_STATUS = (store as any)
        .getState()
        .Product.detail.data.allowed_transition.getContent()
        .find((s) => (s.name ? s.name.toUpperCase() : '') === type);
      if (!PROCESS_STATUS) {
        AppInjector.get(NotificationService).show('warning', 'Unable to reject item', 5000);
        return;
      }
      this.product.process_status_id = PROCESS_STATUS.id;
    }
    store.dispatch({ type: UPDATE_PRODUCT_REQUESTED, data: this.product, no_redirect: this._no_redirect });
  }

  parseInt(val) {
    return val ? parseInt(val) : '';
  }

  deleteItem(id) {
    if (confirm('Do you want to delete this product?')) {
      store.dispatch({ type: DELETE_PRODUCT_REQUESTED, data: id });
    }
  }

  cloneItem(id) {
    store.dispatch({ type: CLONE_PRODUCT_REQUESTED, data: id });
  }

  newUser(terms) {
    this.utilityService.nextPageWithReferer(
      ['/customer/create'],
      new Redirect(this.router.url, {
        email: terms
      })
    );
  }

  newCollection(terms) {
    this.utilityService.nextPageWithReferer(
      ['/collection/create'],
      new Redirect(this.router.url, {
        name: terms
      })
    );
  }

  askSeller() {
    (Swal as any)
      .fire({
        title: '<h2>Ask seller information about:</h2>',
        html: "<p>Politely explain to the seller what information is missing on this listing</p><p>NB: Please manually translate your message to seller's language</p>",
        input: 'textarea',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Send',
        cancelButtonText: 'Cancel',
        inputValidator: (value) => {
          if (!value) {
            return 'You need to write message';
          }
        }
      })
      .then((result) => {
        if (result.value) {
          this.api.product.completeListing(this.route.snapshot.params.id, { message: result.value }).subscribe((res) => {
            AppInjector.get(NotificationService).show('success', 'Message is sent to seller', 5000);
          });
        }
      });
  }

  subscribeToUser() {
    this.userSubject.pipe(debounceTime(500)).subscribe(
      (term) => {
        if (term) {
          store.dispatch({ type: FILTER_USERS_REQUESTED, com: PRODUCT_COMP, data: { pagination: { page: 1, per_page: 10 }, sort: null, filter: null, search: term } });
        } else {
          if ((store as any).getState().Product.detail.data.user) {
            store.dispatch({
              type: FILTER_USERS_REQUESTED,
              com: PRODUCT_COMP,
              data: { pagination: { page: 1, per_page: 10 }, sort: null, filter: null, search: (store as any).getState().Product.detail.data.user.email }
            });
          } else {
            store.dispatch({ type: FILTER_USERS_REQUESTED, com: PRODUCT_COMP, data: { pagination: { page: 1, per_page: 10 }, sort: null, filter: null, search: null } });
          }
        }
      },
      () => {}
    );
  }

  subscribeToCollection() {
    this.collectionSubject.pipe(debounceTime(500)).subscribe(
      (term) => {
        if (term) {
          store.dispatch({ type: FILTER_COLLECTIONS_REQUESTED, com: PRODUCT_COMP, data: { pagination: { page: 1, per_page: 10 }, sort: null, filter: null, search: term } });
        } else {
          if ((store as any).getState().Product.detail.data.collection) {
            store.dispatch({
              type: FILTER_COLLECTIONS_REQUESTED,
              com: PRODUCT_COMP,
              data: { pagination: { page: 1, per_page: 10 }, sort: null, filter: null, search: (store as any).getState().Product.detail.data.collection.name }
            });
          } else {
            store.dispatch({ type: FILTER_COLLECTIONS_REQUESTED, com: PRODUCT_COMP, data: { pagination: { page: 1, per_page: 10 }, sort: null, filter: null, search: null } });
          }
        }
      },
      () => {}
    );
  }

  log() {
    console.log('error cy');
  }

  returnToSeller(data) {
    store.dispatch({
      type: ADD_DATA_DELIVERY,
      com: PRODUCT_COMP,
      data: {
        object_type: 'product',
        object_id: data.id,
        delivery_type: 'RETURN',
        content: data
      }
    });
  }

  pickup(data) {
    store.dispatch({
      type: ADD_DATA_DELIVERY,
      com: PRODUCT_COMP,
      data: {
        object_type: 'product',
        object_id: data.id,
        delivery_type: 'PICK_UP',
        content: data
      }
    });
  }

  changeTemporaryPrice(type) {
    this.temporaryPriceView = type;
    store.dispatch({
      type: FETCH_PRODUCT_TEMPORARY_PRICE_REQUESTED,
      id: (store as any).getState().Product.detail.data.id,
      filter: this.temporaryPriceView === 'active' ? { onlyActive: true } : { onlyExpired: true },
      sort: ['sort', '-created_at']
    });
  }

  isCommentShown(id) {
    if (parseInt((store as any).getState().Product.detail.data.process_status_id) === parseInt(id)) {
      return false;
    }
    let processStatus = store.getState().ProcessStatus.all.items.find((s) => parseInt(s.id) === parseInt(id));
    if (processStatus) {
      return !!processStatus.is_comment_allowed;
    }
    return false;
  }

  reprocessImage() {
    store.dispatch({
      type: REPROCESS_IMAGE_REQUESTED,
      data: {
        id: (store as any).getState().Product.detail.data.id
      }
    });
  }

  deleteImageFn(media) {
    store.dispatch({ type: PRODUCT_EDIT_PAGE_DELETE_IMAGE_REQUESTED, product_id: this.getProductId(), media_id: media.id });
  }

  onForceSold = (form) => {
    if (confirm('Do you want to force update as sold product?')) {
      store.dispatch({ type: UPDATE_PRODUCT_SOLD_FORCE_REQUESTED, data: this.product });
    }
  };
}
